// extracted by mini-css-extract-plugin
export default {"login-success-wrapper":"loginSuccess_login-success-wrapper__UGW+6"};